module.exports = __webpack_public_path__ + "static/media/6-3.6a7d2e67.mp3";